/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { func, shape, bool, number, string } from "prop-types";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux/actions";

import { actions as communicationActions, selectors as communicationSelectors } from "reducers/communication";
import { selectors as sessionSelectors } from "reducers/session";

import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import Reader from "pages/communications/_components/Reader";
import PageLoading from "pages/_components/PageLoading";
import ModalEnvironments from "pages/communications/_components/ModalEnvironments";
import WrongEnvironmentModal from "./_components/WrongEnvironmentModal";

import ModalMessage from "./_components/ModalMessage";

class ReadMessage extends Component {
    state = {
        modalOpen: false,
        deleteMsg: null,
        isPopupVisible: false,
        environment: "",
    };

    static propTypes = {
        dispatch: func.isRequired,
        isDesktop: bool.isRequired,
        isFetching: bool.isRequired,
        detail: shape({
            body: string,
            communicationTray: shape({
                name: string,
            }),
            idCommunication: number,
            subject: string,
            sentDateAsString: string,
        }).isRequired,
        isWrongEnvironmentModalVisible: bool.isRequired,
        correctEnvironmentName: string.isRequired,
        activeEnvironment: string.isRequired,
        wrongEnvironmentMessageKey: string.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentWillMount() {
        window.showPopup = (idTransaction, idEnvironment, environment) => {
            const { dispatch, activeEnvironment } = this.props;
            if (idEnvironment === activeEnvironment.id) {
                dispatch(routerActions.push(`/transaction/${idTransaction}`));
            } else {
                this.setState({ isPopupVisible: true, environment });
            }
        };
    }

    componentDidMount() {
        const { dispatch, ...rest } = this.props;

        dispatch(communicationActions.detailRequest(rest.match.params.id));
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, detail } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.detail !== detail)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, detail } = this.props;
        const subject = detail && detail[0] ? detail[0].subject : "";
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["communicationsRead"],
            goBackPath: "/communications",
            ...(subject ? { headerTitle: subject } : { titleKey: "chat.title" }),
        });
    };

    closeModal = () => {
        const { dispatch } = this.props;
        dispatch(communicationActions.hideWrongEnvironmentModal());
    };

    isModalVisible = (e, state) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        this.setState({ modalOpen: state });
    };

    handleModalDelete = (deleteFunction) => {
        this.setState({ deleteMsg: deleteFunction });
    };

    render() {
        const {
            isDesktop,
            detail,
            isFetching,
            isWrongEnvironmentModalVisible,
            correctEnvironmentName,
            wrongEnvironmentMessageKey,
            embeddedInV3Shell,
        } = this.props;
        const { modalOpen, deleteMsg, isPopupVisible, environment } = this.state;

        const hideLegacyMobileHead = embeddedInV3Shell && isUxDashboardImprovementsEnabled() && !isDesktop;

        return (
            <>
                <PageLoading loading={isFetching}>
                    {!embeddedInV3Shell && <Notification scopeToShow="communicationsRead" />}
                    {isDesktop
                        ? detail && <Head titleText={detail[0].subject} closeLinkTo="/communications" />
                        : detail &&
                          !hideLegacyMobileHead && (
                              <Head
                                  titleText={detail[0].subject}
                                  backLinkTo="/communications"
                                  emptyRightOption
                                  titleClassName="header-mobile-title-background-blue"
                                  headerClassName="blue-main-header-mobile"
                              />
                          )}
                    <MainContainer>
                        <Reader
                            isDesktop={isDesktop}
                            isModalVisible={this.isModalVisible}
                            handleModalDelete={this.handleModalDelete}
                        />
                        <WrongEnvironmentModal
                            isVisible={isWrongEnvironmentModalVisible}
                            isDesktop={isDesktop}
                            closeModal={this.closeModal}
                            environment={correctEnvironmentName}
                            warningMessageKey={wrongEnvironmentMessageKey}
                        />
                        <ModalEnvironments
                            environment={environment}
                            isVisible={isPopupVisible}
                            submitClick={() => {
                                this.setState({ isPopupVisible: false });
                            }}
                        />
                    </MainContainer>
                    <ModalMessage
                        isVisible={modalOpen}
                        submitClick={deleteMsg}
                        cancelClick={(e) => this.isModalVisible(e)}
                    />
                </PageLoading>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    detail: communicationSelectors.detail(state),
    isFetching: communicationSelectors.isFetching(state),
    isWrongEnvironmentModalVisible: communicationSelectors.isWrongEnvironmentModalVisible(state),
    correctEnvironmentName: communicationSelectors.correctEnvironmentName(state),
    wrongEnvironmentMessageKey: communicationSelectors.wrongEnvironmentMessageKey(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(ReadMessage);
